import BookIcon from "@app/icons/dashboard/book";
import UserIcon from "@app/icons/dashboard/user";
import UserPaymentIcon from "@app/icons/dashboard/user-payment";
import UserNewIcon from "@app/icons/dashboard/user-new";
import AuthorIcon from "@app/icons/dashboard/author";
import clsx from "clsx";
import { memo, useEffect, useState } from "react";
import { GeneralInformation as GeneralInformationType } from "@app/types/dashboard.type";
import DashboardService from "@app/services/http/dashboard.service";
import { StatisticsState } from "@app/types";

const Items = [
  {
    label: "Tổng số sách",
    key: "totalBook",
    icon: BookIcon,
    classBackground: "bg-[#5570F1]",
  },
  {
    label: "Tổng số follow",
    key: "totalFollower",
    icon: UserIcon,
    classBackground: "bg-[#771BCC]",
  },
  {
    label: "Tổng số user nghe vip",
    key: "totalBookVipListen",
    icon: UserPaymentIcon,
    classBackground: "bg-[#FFAB00]",
  },
  {
    label: "Tổng số user mua lẻ",
    key: "totalPurchaseBook",
    icon: UserNewIcon,
    classBackground: "bg-[#71DD37]",
  },
  {
    label: "Tổng số user nghe free",
    key: "totalBookFreeListen",
    icon: AuthorIcon,
    classBackground: "bg-[#FF3E1D]",
  },
];

const GeneralInformation = ({ filter }: { filter: StatisticsState }) => {
  const [data, setData] = useState<GeneralInformationType>();

  useEffect(() => {
    DashboardService.getGeneralInformation({
      startDate: filter.startDate || undefined,
      endDate: filter.endDate || undefined,
    }).then((res) => {
      setData(res.data);
    });
  }, [filter.startDate, filter.endDate]);

  return (
    <div className="text-white flex flex-wrap justify-start gap-[24px]">
      {Items.map((item, index) => (
        <div
          key={index}
          className={clsx(
            "w-[193px] h-[140px] rounded-[12px] flex flex-col gap-4 p-[24px]",
            item.classBackground
          )}
        >
          <div className="flex gap-4 items-center">
            <div className="w-[40px] h-[40px] bg-[#FFFFFF] bg-opacity-20 rounded-[8px] flex items-center justify-center">
              <item.icon />
            </div>
            <p className="text-[24px] font-medium">
              {data?.[item.key as keyof GeneralInformationType] ?? 0}
            </p>
          </div>
          <p className="text-[14px]">{item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default memo(GeneralInformation);
